export interface PostMessageConfig {
  session_type?: string;
  return_type?: string;
  forceRedirectInNewWindow?: boolean;
}

const postMessageService = {
  sendFinish: (returnUrl: string, config: PostMessageConfig): void => {
    if (config.return_type !== 'postMessage') {
      return;
    }

    const parsedURL = new URL(returnUrl);
    const sessionType = config.session_type;
    const forceRedirectInNewWindow = config.forceRedirectInNewWindow;

    if (sessionType === 'recurring') {
      window.postMessage(
        {
          source: 'embed2',
          type: sessionType,
          planId: parsedURL.searchParams.get('plan_id'),
          forceRedirectInNewWindow,
        },
        '*',
      );
    } else {
      window.postMessage(
        {
          source: 'embed2',
          type: sessionType,
          reference: parsedURL.searchParams.get('reference'),
          status: parsedURL.searchParams.get('status'),
          forceRedirectInNewWindow,
        },
        '*',
      );
    }
  },

  sendCancellation: (config: PostMessageConfig): void => {
    if (config.return_type !== 'postMessage') {
      return;
    }

    window.postMessage({ source: 'embed2', status: 'cancelled' }, '*');
  },
};

export { postMessageService };
